import React from "react";
import { component_tool } from '../../../../tool'
import moment from "moment";
import { WizTableForm } from "../../../common";
let { WizDataTable, WizButton, WizDivider } = component_tool
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1, isNotAuth: false } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1, isNotAuth: true } })

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '';
}

export default (self, planList) => {
  let {planId, status,resetType} = self.state
  if (resetType && resetType === 1) {
    planId = self.filters && self.filters.planId ? self.filters.planId : undefined
    status = self.filters && self.filters.status ? self.filters.status : undefined
  }
  let disabled = false
  if (planList && planList.length === 1) {
    disabled = true
  }
  let oper = []
  let btns = (self.getMenuBtn() || []).map((btn) => { return btn['code'] })
  if (btns.indexOf('viewJobs') !== -1) {
    oper.push(
      {
        title: "操作",
        tableItem: {
          // fixed: 'right',
          render: (text, record) => {
            let {planStartTime,status} = record
            let btnDisabled = disabled ? true :false
            let ps = moment(planStartTime).format('YYYY-MM-DD HH:mm')
            let nowDate = moment(new Date()).format('YYYY-MM-DD HH:mm')
            if(ps <= nowDate || status !== 1) {
              btnDisabled = true
            }
            return (
              <>
              <WizDataTable.Oper>
                <WizButton tooltip="调整安排" disabled={btnDisabled} onClick={e => self._onAdjustPlan(record,e)}>
                  调整安排
                </WizButton>
                <WizDivider  type="vertical" />
                <WizButton tooltip="查看" onClick={e => self._onLookVerify(record, e)}>
                  查看
                </WizButton>
                <WizDivider  type="vertical" />
                <WizButton tooltip="查看任职" onClick={e => self._onLookPosition(record, e)}>
                  查看任职
                </WizButton>
              </WizDataTable.Oper>
                </>
            )
          }
        }
      }
    )
  }
  return [
    {
      name: "id",
      key: "id",
      formItem: {
        type: "hidden",
      }
    },
    {
      title: 'applyId',
      name: 'applyId',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: '安排计划',
      name: 'planId',
      searchItem: {
        type: 'select',
        initialValue: planId
      },
      dict:  planList || [],
    },
    {
      title: '报名状态',
      name: 'status',
      searchItem: {
        type: "select",
        initialValue:status
      },
      dict: [
        { code: 0, codeName: '待审核' },
        { code: 1, codeName: '已通过' },
        { code: 2, codeName: '审核中' },
        { code: 3, codeName: '未通过' },
        { code: 4, codeName: '已取消报名' }
      ],
    },
    {
      title: '账号',
      name: 'userName',
      tableItem: {},
      searchItem: {}
    },
    {
      title: '姓名',
      name: 'fullName',
      tableItem: {},
      searchItem: {}
    },
    {
      title: '组织',
      name: 'orgId',
      searchItem: {
        ...organizationConfig,
        diy: WizTableForm,
        selectType: 'radio',
      },
    },
    {
      title: '手机号',
      name: 'mobile',
      tableItem: {},
    },
    {
      title: '组织名称',
      name: 'orgName',
      tableItem: {},
    },
    {
      title: '组织编码',
      name: 'orgCode',
      tableItem: {},
    },
    {
      title: '岗位',
      name: 'positionId',
      searchItem: {
        ...positionConfig,
        diy: WizTableForm,
        selectType: 'radio'
      },
    },
    {
      title: '岗位',
      name: 'positionName',
      tableItem: {},
    },
    {
      title: '任职状态',
      name: 'jobState',
      tableItem: {},
      dict: [
        { code: 0, codeName: '离职' },
        { code: 1, codeName: '在职' },
      ],
    },
    {
      title: '安排计划',
      name: 'planName',
      tableItem: {},
    },
    {
      title: '报名状态',
      name: 'status',
      tableItem: {},
      dict: [
        { code: 0, codeName: '待审核' },
        { code: 1, codeName: '已通过' },
        { code: 2, codeName: '审核中' },
        { code: 3, codeName: '未通过' },
        { code: 4, codeName: '已取消报名' }
      ]
    },
    {
      title: '报名提交时间',
      name: 'applySubmitTime',
      tableItem: {
        render: (text) => {
          return formatterDate(text)
        }
      },
    },
    {
      title: '申请人账号',
      name: 'applicantUserName',
      tableItem: {},
    },
    {
      title: '申请人姓名',
      name: 'applicantFullName',
      tableItem: {},
    },
    {
      title: '申请人邮箱',
      name: 'applicantEmail',
      tableItem: {},
    },
    ...oper
  ]
}
